import { render, staticRenderFns } from "./VideoMediaicon.vue?vue&type=template&id=f89fc8f0&scoped=true"
import script from "./VideoMediaicon.vue?vue&type=script&lang=js"
export * from "./VideoMediaicon.vue?vue&type=script&lang=js"
import style0 from "./VideoMediaicon.vue?vue&type=style&index=0&id=f89fc8f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89fc8f0",
  null
  
)

export default component.exports